import { useCallback, useEffect, useState } from "react";
import HomeSection from "../../Sections/HomeSection";
import SideSection from "../../Sections/SideSection";
import NavBar from "../../Components/NavBar/NavBar";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../app/slices/auth";
import AuthVerify from "../../app/AuthVerify";

const AuthSuccess = (props) => {
  const [sideToggle, setSideToggle] = useState(false);
  const clickHandler = () => setSideToggle(!sideToggle);

  const mouseOverHandler = () => {
    setSideToggle(false);
  };
  const mouseOutHandler = () => {
    setSideToggle(true);
  };
  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const logOuthandler = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);
  useEffect(() => {
    if (!currentUser) {
      return <Navigate to="/login" />;
    }
  },[])
  

  return (
    <>
      <AuthVerify logOut={logOuthandler} />{" "}
      {/*It will logout after expiration of JWT */}
      {props.showMenu ? (
        <>
          <NavBar
            isActicveClass={sideToggle ? "bx-menu" : "bx-menu-alt-right"}
            navClickHandler={clickHandler}
            onLogOut={logOuthandler}
          />
          <SideSection
            onMouseOver={mouseOverHandler}
            onMouseOut={mouseOutHandler}
            addClass={sideToggle ? "active" : ""}
          />
          <HomeSection homeClass={sideToggle ? "home-active" : ""}>
            <Outlet />
          </HomeSection>
        </>
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default AuthSuccess;
